import { useTranslation } from 'react-i18next';

import TableBody from 'components/stateless/Table/TableBody';
import TableBorder from 'components/stateless/Table/TableBorder';
import type { HeaderType } from 'components/stateless/Table/TableHeader';
import TableHeader from 'components/stateless/Table/TableHeader';
import Td from 'components/stateless/Table/Td';
import Tr from 'components/stateless/Table/Tr';
import type { CURRENCY_TYPE } from 'enums';
import type { BigNumber } from 'utils/bigNumber';
import type { AnchorArListElementType } from 'utils/http/api/anchor/ar-summaries/request';

interface AnchorAPRequestModalPropsType {
  dataList: AnchorArListElementType[];
  totalCount: number;
  totalAmount: BigNumber;
  currencyType: CURRENCY_TYPE | undefined;
  partnerNames: string[];
}

function AnchorAPRequestModal({
  dataList,
  totalCount,
  totalAmount,
  currencyType,
  partnerNames,
}: AnchorAPRequestModalPropsType) {
  const { t } = useTranslation(['format']);
  const renderResultTable = () => {
    return dataList?.map((item: AnchorArListElementType, i: number) => {
      return (
        <Tr key={i}>
          <Td data={partnerNames[i]} />
          <Td data={item.partnerTaxCode} />
          <Td data={item.arNumber} />
          <Td data={item.arIssuedDate} format="date" />
          <Td data={item.settlementDate} format="date" />
          <Td data={Number(item.arAmount)} format="number" />
        </Tr>
      );
    });
  };

  const tableHeaders: HeaderType[] = [
    {
      headerText: t('text:Partner_Name'),
      className: 'text-center',
    },
    {
      headerText: t('text:Partner_Tax_Code'),
      className: 'text-center',
    },
    {
      headerText: t('text:AP_Number(Tax_Invoice_Number)'),
      className: 'text-center',
    },
    {
      headerText: t('text:AP_Issued_Date'),
      className: 'text-center',
    },
    {
      headerText: t('text:Settlement_Date'),
      className: 'text-center',
    },
    {
      headerText: `${t('text:AP_Amount')} (${t('text:unit')}: ${currencyType ? currencyType : ''})`,
      className: 'text-center',
    },
  ];

  return (
    <>
      <h6>
        {t('text:Would_you_like_to_register_the_AP_information')}
        <br />
        {t('text:Check_the_AP_information_entered_below')}
      </h6>
      <br />
      <ul className="invoice-registration-sum">
        <li>
          • {t('text:Total_number_of_AP_to_register')} : <strong>{t('format:number', { value: totalCount })}</strong>
        </li>
        <li>
          • {t('text:Total_amount_of_AP_to_register')} : <strong>{t('format:number', { value: totalAmount })}</strong>
        </li>
      </ul>
      <br />
      <TableBorder>
        <TableHeader header={tableHeaders} />
        <TableBody numOfCol={5}>{renderResultTable()}</TableBody>
      </TableBorder>
    </>
  );
}

export default AnchorAPRequestModal;
